// src/pages/widgets/Traffic.jsx (경로는 사용 중인 위치에 맞게)

import WidgetShellCard from './WidgetShellCard';
import { useDashboard } from '../dashboards/DashboardContext';
import MiniLineChartMonth from '../charts/MiniLineChartMonth';
import styles from './Widget.module.css';

export default function Traffic({ title, data, value, unit, color, shape }) {
    const { year, month } = useDashboard();

    // 모바일에서 헤더 오른쪽에 표시할 값
    const headerRight = (
        <div className={styles.trafficHeaderValue}>
            <span className={styles.trafficHeaderValueBig}>{value}</span>
            <span className={styles.trafficHeaderValueUnit}>{unit}</span>
        </div>
    );

    return (
        <WidgetShellCard
            title={title}
            className={styles.card__blue}
            headerRight={headerRight} // ⬅️ 타이틀 오른쪽에 값
        >
            <div className={styles.traffic}>
                {/* PC/태블릿에서만 보이는 큰 값 영역 */}
                <div className={styles.traffic__valueDesktop}>
                    <div className={styles.big}>{value}</div>
                    <div className={styles.unit}>{unit}</div>
                </div>

                <MiniLineChartMonth series={[{ points: data, color, shape }]} year={Number(year)} month={Number(month)} />
            </div>
        </WidgetShellCard>
    );
}
